<template>
    <div class="msg-subscr-msanage">
        <div class="hint block mb10">
            <div class="title">温馨提示</div>
            <p>逐条检查：一条一条的检查，因数据较多花费时间较长</p>
        </div>
        <div class="hint block mb10">
            <p>逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长</p>
        </div>
        <div class="hint block">
            <p>导入excel文件的单元格格式推荐使用常规或文本</p>
        </div>
        <div class="message-body mt10">
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <!--<div class="table-th" style="text-align: left">正确示例</div>-->
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必填，可在系统中手动输入</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">定义编码</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中手工输入，商户唯一</div>
                    <!-- <div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">分类</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">资产分类与商品分类选填一种（可在系统中进行选择以系统为准）,填写资产分类后会带出关联的商品分类</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">品牌</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">资产品牌与商品品牌选填一种（可在系统中进行选择以系统为准）,填写资产品牌后会带出关联的商品品牌</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">型号</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">不能超过30个字符且[型号]+[规格]不能超过60个字符</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">规格</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">不能超过45个字符且[型号]+[规格]不能超过60个字符</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">组装件描述全称</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中手动输入，默认=名称+型号+规格</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">单位</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">系统对每类资产有一个默认单位，不填写的情况下直接使用此单位。商户应对每类每批次定一个固定单位</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-asmbl-acc-def-format-expl',
        desc: '组装件定义导入文件格式说明',
        props: {
            scopeId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/asmblAcc/AsmblAccDefFormatExpl.vue